















































































































import mixins from 'vue-typed-mixins'
import ficheImplantationMixin from './ficheImplantationMixin'
import { FicheImplantation_DemandeDuplicata } from '@/domain/FicheImplantation_DemandeDuplicata'
import validationMixin from '@/plugins/mixins/validationMixin'

export default mixins(ficheImplantationMixin, validationMixin).extend({
    data() {
        return {
            demandesDuplicata: new Array<FicheImplantation_DemandeDuplicata>(),
            demandeDuplicata: new FicheImplantation_DemandeDuplicata(),
            nav: 'tab-envoi',
            choix: null,
            files: new Array<File>(),
            messageConfirmationUpload: null as null | string,

            formulaireDemande: false
            // messageConfirmationDemande: null as null | string,
            // messageWarningDemande: null as null | string
        }
    },
    mounted() {
        this.$loader.go()
        this.getDemandesDatatable()
            .then(x => {
                this.demandesDuplicata = x
            })
            .finally(() => this.$loader.stop())

        this.demandeDuplicata = new FicheImplantation_DemandeDuplicata()
        this.demandeDuplicata.mailReponse = this.$database.account.email
    },
    computed: {
        headersDemandeDuplicata(): any {
            return this.isMobileDevice()
                ? [
                      { text: 'Patient', value: 'nomPatient' },
                      { text: 'Date', value: 'date' }
                  ]
                : [
                      { text: 'Patient', value: 'nomPatient' },
                      { text: 'Numéro de greffon', value: 'numeroGreffon' },
                      { text: 'Chirurgien', value: 'nomChirurgien' },
                      { text: 'Date', value: 'date' },
                      { text: 'Statut', value: 'statut' }
                  ]
        }
    },
    methods: {
        addFile() {
            this.ajouterFichier(this.files)
        },
        saveDemandeDuplicata() {
            this.saveDemandeDuplication(this.demandeDuplicata).then(() => {
                this.demandeDuplicata = new FicheImplantation_DemandeDuplicata()
                this.getDemandesDatatable()
                    .then(x => {
                        this.demandesDuplicata = x.data
                        this.choix = null
                    })
                    .finally(() => this.$loader.stop())
            })
        }
    }
})
